<template>
  <b-container fluid>
    <!-- <AppLoader v-if="!isGlobalLoader" small /> -->
    <b-spinner
      v-if="isLoading"
      type="grow"
      class="text-center"
      style="margin-top: 10%; position:absolute;"
      variant="primary"
    ></b-spinner>
    <b-navbar toggleable="lg" type="dark" variant="light">
      <b-navbar-brand href="#" class="text-dark">
        <strong>Forms</strong>
      </b-navbar-brand>

      <!-- <b-navbar-toggle target="nav-collapse"></b-navbar-toggle> -->

      <b-collapse id="nav-collapse" is-nav>
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-form>
            <b-button
              class="my-2 my-sm-0 mr-2"
              variant="outline-primary"
              size="sm"
              @click="showNewCreateFormModal = !showNewCreateFormModal"
            >
              <font-awesome-icon icon="plus" />
            </b-button>
            <b-button
              variant="outline-info"
              size="sm"
              style="margin-right:30px;"
              @click="reloadTable"
            >
              <font-awesome-icon icon="sync" />
            </b-button>

            <b-form-group
              label-cols-sm="3"
              label-align-sm="right"
              label-size="sm"
              label-for="filterInput"
            >
              <b-input-group size="sm">
                <b-form-input
                  v-model="filter"
                  type="search"
                  id="filterInput"
                  placeholder="Type to Search"
                ></b-form-input>
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="filter = ''"
                    >Clear</b-button
                  >
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-nav-form>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <b-table
      class="mx-1"
      sticky-header="calc(100vh - 200px)"
      ref="table"
      id="my-table"
      :busy.sync="isLoading"
      :items="myProvider"
      :fields="fields"
      :filter="filter"
      :per-page="perPage"
      :current-page="currentPage"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      responsive="sm"
    >
      <template v-slot:cell(type)="data">
        <p>{{ formTypes[data.item.type - 1] }}</p>
      </template>

      <template v-slot:cell(created_updated)="data">
        <p>{{ age(data.item.created_at) }}</p>
      </template>

      <template v-slot:cell(title)="data">
        <a href="#" @click="getForm(data.item.id, '/form/configuration')">{{
          data.item.title
        }}</a>
      </template>

      <template v-slot:cell(is_active)="data">
        <b-badge :variant="data.item.is_active == 1 ? 'success' : 'warning '">{{
          data.item.is_active == 1 ? "Published" : "Draft "
        }}</b-badge>
      </template>

      <template v-slot:cell(actions)="data">
        <font-awesome-icon
          v-b-tooltip.hover
          title="Edit Form"
          class="mx-1 text-primary pointer"
          icon="cogs"
          @click="getForm(data.item.id, '/form/configuration')"
        />
        <font-awesome-icon
          v-b-tooltip.hover
          title="Preview Form"
          class="text-success pointer"
          icon="eye"
          @click="viewUserForm(data.item.id, '/user-form')"
          to="/user-form"
        />
        <font-awesome-icon
          v-b-tooltip.hover
          title="Duplicate Form"
          class="mx-1 text-warning pointer"
          icon="copy"
          @click="
            duplicateFormModal(
              data.item.title,
              data.item.description,
              data.item.id,
              data.item.clientId
            )
          "
        />
        <font-awesome-icon
          :disabled="data.is_active == 0"
          v-b-tooltip.hover
          title="Delete Form"
          :class="
            data.item.is_active == 0
              ? 'mx-1 text-danger pointer'
              : 'mx-1 text-light pointer'
          "
          icon="trash"
        />

        <!-- <b-button @click="showFormStats(data.item.company_id)" href="/stats" v-b-tooltip.hover variant="outline" title="Show Stats" size="sm"> 
        <font-awesome-icon
          size="2x"
          icon="chart-line"          
        /></b-button> -->
      </template>
      <!-- <template v-slot:cell(selection)="data">
            <b-form-checkbox
              :id="'checkbox'+data.index"
              v-model="data.index"
              name="checkbox-1"
              value="selected"
              unchecked-value="not_selected"
            ></b-form-checkbox>
      </template>-->
    </b-table>

    <b-row>
      <b-col cols="1">
        <b-form-select
          v-model="perPage"
          id="perPageSelect"
          size="sm"
          :options="pageOptions"
        ></b-form-select>
      </b-col>
      <b-col>
        <b-pagination
          class="float-right"
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          first-text="First"
          prev-text="Prev"
          next-text="Next"
          last-text="Last"
          aria-controls="my-table"
        ></b-pagination>
      </b-col>
    </b-row>

    <b-modal
      id="bv-modal-newform"
      size="lg"
      v-model="showNewCreateFormModal"
      scrollable
      no-close-on-backdrop
      hide-footer
      :hide-header="isGlobalLoader"
    >
      <template v-slot:modal-header="{ close }">
        <!-- Emulate built in modal header close button action -->

        <h5>Create New Form</h5>
      </template>
      <AppLoader v-if="isGlobalLoader" small />
      <b-form v-if="!submiting && !responseSuccess">
        <b-form-group label="Client">
          <v-select
            :searchable="true"
            :clearable="true"
            label="text"
            code="value"
            v-model="$v.newForm.clientId.$model"
            :state="
              $v.newForm.clientId.$dirty ? !$v.newForm.clientId.$error : null
            "
            aria-describedby
            :options="clients"
          ></v-select>
          <b-form-invalid-feedback id="input-2-live-feedback"
            >This is a required field and must be select One
            option</b-form-invalid-feedback
          >
        </b-form-group>

        <b-form-group label="Form Title">
          <b-form-input
            placeholder="Enter form title"
            v-model="$v.newForm.formTitle.$model"
            :state="
              $v.newForm.formTitle.$dirty ? !$v.newForm.formTitle.$error : null
            "
            aria-describedby
          ></b-form-input>
          <b-form-invalid-feedback
            >This is a required field and must be at least 5
            characters.</b-form-invalid-feedback
          >
        </b-form-group>

        <b-form-group label="Form Description">
          <b-form-textarea
            placeholder="Enter the form description"
            rows="3"
            v-model="$v.newForm.formDescription.$model"
            :state="
              $v.newForm.formDescription.$dirty
                ? !$v.newForm.formDescription.$error
                : null
            "
            aria-describedby
          ></b-form-textarea>
          <b-form-invalid-feedback
            >This is a required field and must be at least 10
            characters.</b-form-invalid-feedback
          >
        </b-form-group>

        <b-form-group label="Form Type">
          <!-- <v-select
            :searchable="true"
            label="text"
            v-model="$v.newForm.selectFormType.$model"
            :state="
              $v.newForm.clientId.$dirty ? !$v.newForm.clientId.$error : null
            "
            aria-describedby
            :options="optionsFormType"
          ></v-select> -->

          <b-form-radio-group
            id="radio-group-1"
            v-model="$v.newForm.selectFormType.$model"
            :state="
              $v.newForm.selectFormType.$dirty
                ? !$v.newForm.selectFormType.$error
                : null
            "
            :options="optionsFormType"
            name="radio-options"
          ></b-form-radio-group>
          <b-form-invalid-feedback
            >This is a required field and must be select One
            option</b-form-invalid-feedback
          >
        </b-form-group>
      </b-form>

      <div v-else-if="submiting && !responseSuccess">
        <p>Your Form is being submited......</p>
        <b-spinner type="grow" label="Loading..."></b-spinner>
      </div>

      <div v-else>
        <p class="my-2 text-center">
          Your form has been created successfully. Would you like to create
          another form?
          <br />
        </p>
        <p class="text-center mt-3">
          <b-button
            @click="responseSuccess = !responseSuccess"
            variant="primary"
            size="lg"
            >Create a new form</b-button
          >
        </p>
        <p class="my-2 text-center">Would you like to edit that form.</p>
        <p class="text-center mb-5 mt-3">
          <b-button
            title="Edit Form"
            class="mr-2 text-primary"
            @click="getForm(newFormId, '/form/configuration')"
          >
            <font-awesome-icon icon="edit" />
          </b-button>
        </p>
      </div>

      <div class="float-right">
        <b-button
          class="mr-3"
          id="close-btn"
          variant="secondary"
          v-if="!submiting"
          @click="resetForm"
          >Close</b-button
        >
        <b-button
          v-if="!responseSuccess"
          variant="outline-success"
          :disabled="$v.newForm.$invalid"
          @click="createForm"
        >
          <b-spinner v-if="submiting" type="grow" label="Loading..."></b-spinner
          >Create
        </b-button>
      </div>

      <div class="clearfix"></div>
    </b-modal>

    <b-modal
      id="bv-modal-duplicateform"
      size="lg"
      no-close-on-backdrop
      v-model="showDuplicateFormModal"
      scrollable
      hide-footer
    >
      <template v-slot:modal-header="{ close }">
        <h5>Duplicate Form</h5>
      </template>
      <div>
        <b-form v-if="!submiting && !responseSuccess">
          <b-form-group label="Client">
            <v-select
              :searchable="true"
              :clearable="true"
              label="text"
              code="value"
              v-model="$v.duplicateForm.duplicateClientId.$model"
              :state="
                $v.duplicateForm.duplicateClientId.$dirty
                  ? !$v.duplicateForm.duplicateClientId.$error
                  : null
              "
              aria-describedby
              :options="clients"
            ></v-select>
            <b-form-invalid-feedback
              >This is a required field and must be select One
              option</b-form-invalid-feedback
            >
          </b-form-group>
          <b-form-group label="Form Title">
            <b-form-input
              placeholder="Enter form title"
              v-model="$v.duplicateForm.duplicateTitle.$model"
              :state="
                $v.duplicateForm.duplicateTitle.$dirty
                  ? !$v.duplicateForm.duplicateTitle.$error
                  : null
              "
            ></b-form-input>
            <b-form-invalid-feedback
              >This is a required field and must be at least 5
              characters.</b-form-invalid-feedback
            >
          </b-form-group>
          <b-form-group label="Form Description">
            <b-form-textarea
              placeholder="Enter the form description"
              rows="3"
              v-model="$v.duplicateForm.duplicateDescription.$model"
              :state="
                $v.duplicateForm.duplicateDescription.$dirty
                  ? !$v.duplicateForm.duplicateDescription.$error
                  : null
              "
            ></b-form-textarea>
            <b-form-invalid-feedback
              >This is a required field and must be at least 10
              characters.</b-form-invalid-feedback
            >
          </b-form-group>
          <b-form-group label="Form Type">
            <b-form-radio-group
              id="radio-group-1"
              v-model="$v.duplicateForm.duplicateselectFormType.$model"
              :state="
                $v.duplicateForm.duplicateselectFormType.$dirty
                  ? !$v.duplicateForm.duplicateselectFormType.$error
                  : null
              "
              :options="optionsFormType"
              name="radio-options"
            ></b-form-radio-group>
            <b-form-invalid-feedback
              >This is a required field and must be select One
              option</b-form-invalid-feedback
            >
          </b-form-group>
        </b-form>
        <div v-else-if="submiting && !responseSuccess">
          <p>Your Form is being submited......</p>
          <b-spinner type="grow" label="Loading..."></b-spinner>
        </div>

        <div v-else>
          <p class="my-2 text-center">
            Your form has been created successfully.
            <br />
          </p>
        </div>
        <div class="float-right">
          <b-button
            class="mr-3"
            id="close-btn"
            variant="danger"
            v-if="!submiting"
            @click="resetDuplicateForm"
            >Close</b-button
          >
          <b-button
            v-if="!responseSuccess"
            variant="outline-success"
            :disabled="$v.duplicateForm.$invalid"
            @click="duplicateForms"
          >
            <b-spinner
              v-if="submiting"
              type="grow"
              label="Loading..."
            ></b-spinner
            >Create
          </b-button>
        </div>
        <div class="clearfix"></div>
      </div>
    </b-modal>
  </b-container>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
// import Layouts from "./layout";
import { HTTP } from "../../utils/HTTP";
// import { Helper } from "../helpers";
import AppLoader from "../../components/Loader/Loader";
import uid from "uid";
import moment from "moment";
import "moment/locale/es";
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import Cryptr from "cryptr";
export default {
  name: "FormsContainer",
  mixins: [validationMixin],
  data() {
    return {
      perPage: 10,
      totalRows: 0,
      currentPage: 1,
      sortBy: "id",
      sortDesc: true,
      pageOptions: [5, 10, 25, 50, 75, 100],
      fields: [
        { key: "id", label: "id", sortable: true },
        { key: "type", label: "Type", sortable: true },
        { key: "title", sortable: true },
        { key: "company_name", label: "Company Name", sortable: true },
        { key: "company_id", label: "Company Id", sortable: true },
        { key: "name", label: "Creator Name", sortable: true },
        { key: "created_updated", sortable: true },
        { key: "is_active", sortable: false },
        { key: "actions", sortable: false },
        { key: "selection", label: "", sortable: false },
      ],
      filter: null,
      formTypes: [
        "External Questionaire",
        "Survey",
        "Training",
        "Exam",
        "Executive Summary",
        "PDF Uploads",
        "Internal Questionaire",
        "Signature Form",
        "Internal Company Form",
        "Certification Form",
        "Training With Practice Exam",
        "Practice Exam",
      ],
      isLoading: false,
      submiting: false,
      isHidden: false,
      responseSuccess: false,
      placeholderVersion: "e.g. 1.0.2",
      newForm: {
        formTitle: null,
        formDescription: null,
        clientId: null,
        selectFormType: 1,
      },
      optionsFormType: [
        { value: 1, text: "External Questionaire" },
        { value: 2, text: "Survey" },
        { value: 3, text: "Training" },
        { value: 4, text: "Exam" },
        { value: 5, text: "Executive Summary" },
        { value: 6, text: "PDF Uploads" },
        { value: 7, text: "Internal Questionaire" },
        { value: 8, text: "Signature Form" },
        { value: 9, text: "Internal Company Form" },
        { value: 10, text: "Certification Form" },
        { value: 11, text: "Training With Practice Exam" },
        { value: 12, text: "Practice Exam" },
      ],
      translationLanguage: "english",
      showNewCreateFormModal: false,
      showDuplicateFormModal: false,
      showCollapse: true,
      clients: [],
      formTable: [],
      duplicateForm: {
        duplicateTitle: null,
        duplicateDescription: null,
        duplicateselectFormType: null,
        duplicateClientId: null,
      },
      duplicateId: null,
      duplicateClientId: null,
      newFormId: null,
    };
  },

  validations: {
    newForm: {
      formTitle: {
        required,
        minLength: minLength(5),
      },
      formDescription: {
        required,
        minLength: minLength(10),
      },
      selectFormType: {
        required,
      },
      clientId: {
        required,
      },
    },
    duplicateForm: {
      duplicateTitle: {
        required,
        minLength: minLength(5),
      },
      duplicateDescription: {
        required,
        minLength: minLength(10),
      },
      duplicateselectFormType: {
        required,
      },
      duplicateClientId: {
        required,
      },
    },
  },

  components: {
    AppLoader,
  },

  computed: {
    rows() {
      return this.totalRows;
    },

    createdAt(value) {
      return moment(value).format("LLL");
    },

    ...mapGetters({
      form: "form1",
      selectedLanguage: "selectedLanguage",
      isGlobalLoader: "isLoading",
    }),
  },

  mounted() {
    // console.log("mounted templates");
    this.onResetLocalData();
    this.getClientsList();
  },

  methods: {
    ...mapMutations(["UPDATE_FORM"]),

    age(value) {
      moment.locale("en");
      // // console.log(value);
      // let localeData = moment.updateLocale("en", {
      // 	relativeTime: {
      // 		future: "in %s",
      // 		past: "%s ago",
      // 		s: "hello, a few seconds",
      // 		ss: "%d seconds",
      // 		m: "a minute",
      // 		mm: "%d minutes",
      // 		h: "an hour",
      // 		hh: "%d hours",
      // 		d: "a day",
      // 		dd: "%d days",
      // 		M: "a month",
      // 		MM: "%d months",
      // 		y: "a year",
      // 		yy: "%d years"
      // 	}
      // });
      //return moment(value).fromNow();
      return moment.utc(value).fromNow();
    },

    onResetLocalData() {
      // console.log("clearing storage");
      localStorage.removeItem("taskId");
      localStorage.removeItem("examAttemptsToDate");
      localStorage.removeItem("activeTaskStatus");
      localStorage.removeItem("activeFormSchema");
      localStorage.removeItem("examAttemptsToDate");
      localStorage.removeItem("examAttemptId");
      localStorage.removeItem("tempForm");
      localStorage.removeItem("activeFormId");
      localStorage.removeItem("userConsent");
    },

    duplicateFormModal(title, description, id, clientId, type) {
      (this.duplicateForm.duplicateTitle = title),
        (this.duplicateForm.duplicateDescription = description),
        (this.duplicateForm.duplicateselectFormType = type),
        (this.duplicateForm.duplicateClientId = clientId);
      this.duplicateId = id;
      this.showDuplicateFormModal = true;
      // // console.log(type);
    },

    resetForm() {
      this.responseSuccess = false;
      this.submiting = false;
      this.isLoading = false;
      this.showNewCreateFormModal = false;
    },

    resetDuplicateForm() {
      this.responseSuccess = false;
      this.submiting = false;
      this.isLoading = false;
      this.showDuplicateFormModal = false;
    },

    async duplicateFormApiCall() {
      let formData = {
        createdById: localStorage.getItem("userId"),
        clientId: this.duplicateForm.duplicateClientId.value,
        form_id: this.duplicateId,
        formType: this.duplicateForm.duplicateselectFormType,
        formTitle: {
          english: this.duplicateForm.duplicateTitle,
        },
        formDescription: {
          english: this.duplicateForm.duplicateDescription,
        },
      };
      try {
        let token = "Bearer " + localStorage.getItem("accessToken");
        this.submiting = true;
        this.isLoading = true;
        let result = await HTTP("post", "v1/form/duplicate", formData, {
          Authorization: token,
        },null,
          null,
          null,
          process.env.VUE_APP_FORMS_PORTAL_API_URL);
        if (result && result.data.httpStatus == 200) {
          this.submiting = false;
          this.isLoading = false;
          this.responseSuccess = true;
          this.$v.$reset();
          let form = JSON.parse(result.data.form.schema);
          this.updateFormToStore(form);
        }
      } catch (error) {
        this.isLoading = false;
        this.submiting = false;
      }
    },

    duplicateForms() {
      this.$v.duplicateForm.$touch();
      if (this.$v.duplicateForm.$anyError) {
        return;
      }
      this.duplicateFormApiCall().then(this.reloadTable);
    },

    async myProvider(ctx) {
      // Here we don't set isBusy prop, so busy state will be
      // handled by table itself
      let formData = {
        filter: this.filter,
        sort: this.sortBy + "|" + (this.sortDesc == true ? "desc" : "asc"),
        per_page: this.perPage,
        page: this.currentPage,
      };

      let token = "Bearer " + localStorage.getItem("accessToken");
      this.isLoading = true;
      let result = HTTP("post", "v1/getformslist", formData, {
        Authorization: token,
      },null,
          null,
          null,
          process.env.VUE_APP_FORMS_PORTAL_API_URL);

      return result
        .then((response) => {
          const items = response.data.data;
          // Here we could override the busy state, setting isBusy to false
          this.isLoading = false;
          this.totalRows = response.data.total;
          return items;
        })
        .catch((error) => {
          // Here we could override the busy state, setting isBusy to false
          this.isLoading = false;
          // Returning an empty array, allows table to correctly handle
          // internal busy state in case of error
          return [];
        });
    },

    async getClientsList() {
      this.isLoading = true;
      let token = "Bearer " + localStorage.getItem("accessToken");
      try {
        let result = await HTTP("get", "v1/getclientslist", null, {
          Authorization: token,
        },null,
          null,
          null,
          process.env.VUE_APP_FORMS_PORTAL_API_URL);

        this.clients = result.data.clients;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
      }
    },

    async lockUnlockForm(status) {
      let token = "Bearer " + localStorage.getItem("accessToken");
      let activeFormId = localStorage.getItem("activeFormId");
      if (!activeFormId) {
        this.$router.push({
          path: "/templates",
        });
      }
      let userId = localStorage.getItem("userId");
      try {
        let result = await HTTP(
          "put",
          "v1/form/lockstatus/" + activeFormId,
          {
            userId: userId,
            lockStatus: status,
          },

          {
            Authorization: token,
          },
          null,
          true,
          null,
          process.env.VUE_APP_FORMS_PORTAL_API_URL
        );
      } catch (error) {}
    },

    /**when user click on form */
    async getForm(formId, route) {
      localStorage.removeItem("activeFormId");
      this.updateFormToStore({});
      this.isLoading = true;
      let userId = localStorage.getItem("userId");
      let token = "Bearer " + localStorage.getItem("accessToken");
      let result = await HTTP("get", "v1/form/" + formId, null, {
        Authorization: token,
      },null,
          null,
          null,
          process.env.VUE_APP_FORMS_PORTAL_API_URL);

      if (
        (result.data.form.is_locked == 1 &&
          result.data.form.locked_by_user_id == userId) ||
        result.data.form.is_locked == 0
      ) {
        if (result.data.form && result.data.form.schema) {
          let form = JSON.parse(result.data.form.schema);
          localStorage.setItem("activeFormId", formId);
          const cryptr = new Cryptr("myTotalySecretKey");
          const encryptedString = cryptr.encrypt(result.data.form.is_active);
          localStorage.setItem("formStatus", encryptedString);
          await this.lockUnlockForm(1);
          this.updateFormToStore(result.data.form.schema);
          localStorage.setItem("activeFormSchema", result.data.form.schema);
          this.isLoading = false;
          this.$router.push({
            path: route,
            params: {
              from: "home",
            },
          });
        }
      } else {
        this.isLoading = false;
        alert("The form is currently locked and is in use by another user");
      }
    },

    /**
     * Opens form in preview mode
     */
    async viewUserForm(formId, route) {
      localStorage.removeItem("activeFormId");
      this.updateFormToStore({});
      this.isLoading = true;
      let token = "Bearer " + localStorage.getItem("accessToken");
      let result = await HTTP("get", "v1/form/" + formId, null, {
        Authorization: token,
      },null,
          null,
          null,
          process.env.VUE_APP_FORMS_PORTAL_API_URL);
      this.isLoading = false;
      if (result.data.form && result.data.form.schema) {
        let form = result.data.form.schema;
        localStorage.setItem("activeFormId", formId);
        localStorage.setItem("activeFormSchema", form);

        this.$router.push({
          path: route,
          params: {
            from: "home",
          },
        });
      }
    },

    updateFormToStore(form) {
      this.UPDATE_FORM(form);
      // this.reloadTable();
    },

    reloadTable() {
      this.$root.$emit("bv::refresh::table", "my-table");
    },

    async createFormApiCall() {
      this.$v.newForm.$touch();
      if (this.$v.newForm.$anyError) {
        return;
      }
      let formData = {
        createdById: localStorage.getItem("userId"),
        copy_of_form_id: null,
        clientId: this.newForm.clientId.value,
        formId: null,
        formStyle: {
          backgroundColor: null,
          backgroundImage: null,
          backgroundSize: null,
          backgroundRepeat: null,
          backgroundPosition: null,
          height: null,
          width: null,
          opacity: 1,
          padding: {
            top: null,
            right: null,
            bottom: null,
            left: null,
          },
          margin: {
            top: null,
            right: null,
            bottom: null,
            left: null,
          },
          border: {
            top: null,
            right: null,
            bottom: null,
            left: null,
          },
        },
        formTranslationType: "custom",
        formTitle: {
          english: this.newForm.formTitle,
        },
        formDescription: {
          english: this.newForm.formDescription,
        },
        formIntroText: {
          english: null,
        },
        formType: this.newForm.selectFormType,
        formLayout: this.formLayout || "vertical",
        formSection: [
          {
            type: "section",
            id: uid(),
            index: 0,
            name: "",
            isRepeatable: false,
            advance: {
              hideSectionTitle: false,
            },
            sectionTitle: {
              english: "Section 1 Title",
            },
            formElements: [],
          },
        ],
        formStatus: 0,
        formDefaultLanguage: "english",
        formVersion: null,
        formTranslations: ["English"],
        formJSCode: null,
        formCSS: null,
        formRequirePassword: 0,
        formPassword: null,
        formConfiguration: {
          form: {},
          survey: {},
          training: {},
          exam: {
            examTimeLimit: null,
            examMaxAttempts: 5,
            examSequentialAnswer: 0,
          },
        },
      };
      if (formData.formTitle.english || formData.formDescription.english)
        try {
          let token = "Bearer " + localStorage.getItem("accessToken");
          this.submiting = true;
          this.isLoading = true;
          this.newForm.formTitle = null;
          this.newForm.formDescription = null;
          this.newForm.clientId = null;
          // this.showNewCreateFormModal = false;
          let result = await HTTP("post", "v1/createform", formData, {
            Authorization: token,
          },null,
          null,
          null,
          process.env.VUE_APP_FORMS_PORTAL_API_URL);
          if (result && result.data.httpStatus == 200) {
            // this.$root.$emit('bv::refresh::table', 'my-table');
            this.submiting = false;
            this.isLoading = false;
            this.responseSuccess = true;
            this.$v.$reset();
            // this.$bvModal.hide("bv-modal-newform");
            let form = JSON.parse(result.data.form.schema);
            this.newFormId = result.data.formId;
            this.updateFormToStore(form);
          }
        } catch (error) {
          this.submiting = false;
          this.isLoading = false;
        }
    },

    createForm() {
      this.createFormApiCall().then(this.reloadTable);
    },

    // form stats
    showFormStats(companyId) {
      // console.log("companyId", companyId);
      localStorage.setItem("companyId", companyId);
      // this.$router.push("/stats")
    },
  },
};
</script>

<style scoped>
.pointer {
  cursor: pointer;
}

.table-col {
  max-height: calc(100vh - 140px);
  overflow-y: scroll;
}
</style>
